import './index.scss'
wp.blocks.registerBlockStyle( 
  [ 'core/cover', 'core/image' ],
  {
    name: 'thumbnail-hover',
    label: 'Thumbnail Hover'
  },
);


wp.blocks.registerBlockStyle( 
  [ 'core/cover', 'core/image' ],
  {
    name: 'thumbnail-full-hover',
    label: 'Thumbnail Full Hover'
  },
);